import React from 'react';

interface IProps {
  if?: unknown;
  else?: React.ReactNode;
  children: React.ReactNode;
}

const Index: React.FC<IProps> = ({ children, if: condition, else: elseRenderContent = false }) =>
  !condition ? (elseRenderContent as never) : children;

export default Index;
